import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface CompanyMember {
  id: string;
  full_name: string;
  phone: string;
}

export function useCompanyMembers() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['company-members', user?.company_id],
    queryFn: async () => {
      if (!user?.company_id) return [];

      const { data: companyUsers } = await supabase
        .from('company_users')
        .select('user_id')
        .eq('company_id', user.company_id)
        .eq('is_active', true);

      if (!companyUsers?.length) return [];

      const userIds = companyUsers.map(cu => cu.user_id);

      const { data: profiles } = await supabase
        .from('profiles')
        .select('id, full_name, phone')
        .in('id', userIds);

      return (profiles || []).filter(p => p.full_name) as CompanyMember[];
    },
    enabled: !!user?.company_id,
  });
}
